// ProductCardSimple.js

import React from 'react';
import { Link } from 'react-router-dom';
import './ProductCardSimple.css';

const ProductCardSimple = ({ product }) => {
    // Verificar si el primer elemento de media es un video o imagen
    const firstMedia = product.media.length > 0 ? product.media[0] : '/default-image.jpg';
    const isVideo = firstMedia.endsWith('.mp4');

    return (
        <div className="product-card-simple">
            <Link to={`/product/${product._id}`} className="product-link">
                {isVideo ? (
                    <video
                        src={firstMedia}
                        className="product-media"
                        autoPlay
                        muted
                        loop
                        playsInline // Asegura que el video no se agrande en iPhone
                    />
                ) : (
                    <img
                        src={firstMedia}
                        alt={product.name}
                        className="product-image"
                    />
                )}
                <div className="product-info">
                    <h3 className="product-name">{product.name}</h3>
                    <p className="product-price">{product.price.toFixed(2)} €</p>
                </div>
            </Link>
        </div>
    );
};

export default ProductCardSimple;
